import { TableCell, TableCellProps } from '@material-ui/core';
import { FC } from 'react';

const SmallTableCell: FC<TableCellProps> = ({ ...TableCellProps }) => (
  <TableCell width={1} align="center" {...TableCellProps} />
);
export default SmallTableCell;
